import { Fragment, memo } from 'react';
import CivilStatus from '../shared/civil-status';
import EditData from '../shared/edit-data';
import Marriage from './marriage';
import AccordionPerson from 'shell/components/shared/person';

interface RegistrationMarriageProps {
  isFromCivilStatus?: boolean;
}

const RegistrationMarriageComponent = ({
  isFromCivilStatus,
}: RegistrationMarriageProps): React.ReactElement => {
  return (
    <Fragment>
      <AccordionPerson disabled />
      <EditData />
      <CivilStatus disabled />
      <Marriage isFromCivilStatus={isFromCivilStatus} />
    </Fragment>
  );
};

RegistrationMarriageComponent.displayName = 'Registration Marriage component';

const RegistrationMarriage = memo(RegistrationMarriageComponent);

export default RegistrationMarriage;
